export const HEADER_BUTTONS_REGION_ID = "headerButtonsRegionId";
export const OWA_HEADER_BUTTON_GROUP_LEFT_REGION_ID = "owaHeaderButtonGroupLeft_container";
export const OWA_HEADER_BUTTON_GROUP_RIGHT_REGION_ID = "owaHeaderButtonGroupRight_container";
export const OWA_TITLE_BAR_ID = "OwaTitleBar";
export const OWA_SEARCH_SCOPE_PICKER_ID = "owaSearchScopePicker";
export const WINDOW_ICON_HOST_ID = "windowIconsHost";
export const WINDOW_ICON_MINIMIZE_ID = "windowIconMinimize";
export const WINDOW_ICON_MAXIMIZE_ID = "windowIconMaximize";
export const WINDOW_ICON_CLOSE_ID = "windowIconClose";
export const HEADER_BUTTON_SIZE = 48;
